import { Directive } from '@angular/core';

import { isTablet } from '../utils/is-tablet.util';

@Directive()
export abstract class BaseComponentDirective {
  isTablet = isTablet();
}
